/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'VK': {
    width: 16,
    height: 16,
    viewBox: '0 0 19.97 11.392',
    data: '<path pid="0" d="M9.772 11.345h1.193a1.009 1.009 0 0 0 .545-.238.877.877 0 0 0 .164-.524s-.023-1.6.72-1.837 1.674 1.548 2.671 2.232a1.891 1.891 0 0 0 1.327.4l2.667-.037s1.4-.086.734-1.183a8.958 8.958 0 0 0-1.983-2.294c-1.673-1.552-1.449-1.3.566-3.986 1.226-1.635 1.717-2.633 1.564-3.061-.146-.407-1.049-.3-1.049-.3l-3 .019a.682.682 0 0 0-.388.068.842.842 0 0 0-.265.322 17.357 17.357 0 0 1-1.109 2.341c-1.337 2.27-1.872 2.39-2.09 2.249-.509-.329-.382-1.32-.382-2.024 0-2.2.334-3.118-.65-3.355a5.13 5.13 0 0 0-1.4-.139 6.479 6.479 0 0 0-2.492.255c-.341.167-.6.54-.444.561a1.348 1.348 0 0 1 .886.445 2.894 2.894 0 0 1 .3 1.359s.177 2.59-.413 2.912c-.405.221-.96-.23-2.152-2.29A19.1 19.1 0 0 1 4.22 1.019a.9.9 0 0 0-.247-.335 1.245 1.245 0 0 0-.462-.186L.658.517S.23.529.072.717c-.14.166-.011.508-.011.508s2.234 5.226 4.763 7.86a6.854 6.854 0 0 0 4.954 2.257"/>'
  }
})
